import MyAreaCascader from './myAreaCascader'

const myAreaCascader = {
  install(Vue) {
    Vue.component(MyAreaCascader.name, MyAreaCascader)
  }
}

export default myAreaCascader